<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>
        Detail objednávky
      </h1>

      <v-layout>
        <table class="info-table">
          <tr v-if="data.vyfakturuj_id">
            <td class="info-table__title">
              Faktura:
            </td>
            <td class="info-table__value info-table__value--text">
              <v-btn
                @click="downloadBilling()"
                color="primary"
                type="button"
                class="button--small"
                >Stáhnout</v-btn
              >
            </td>
          </tr>
          <!--                   <tr v-if="data.vyfakturuj_id">
                       <td class="info-table__title">

                       </td>
                       <td class="info-table__value info-table__value&#45;&#45;text"  @click="copyBilling()">
                         vyfakturuj č. <b style="cursor:pointer" ref="billingId" >{{data.vyfakturuj_id}}</b> <span >(zkopírovat kliknutím)</span>
                       </td>
                   </tr>-->
          <tr>
            <td class="info-table__title"></td>
            <td
              class="info-table__value info-table__value--text"
              @click="copyNumber()"
            >
              <span
                v-if="data.ios_receipt"
                class="apple-order apple-order--detail"
              ></span>
              objednávka č.
              <b style="cursor:pointer" ref="numberId">{{ data.number }}</b>
              <span>(zkopírovat kliknutím)</span>
            </td>
          </tr>
          <!--                   <tr v-if="data.gopay_id">
                       <td class="info-table__title">

                       </td>
                       <td class="info-table__value info-table__value&#45;&#45;text"  @click="copyGopay()">
                           gopay č. <b style="cursor:pointer" ref="gopayId" >{{data.gopay_id}}</b> <span >(zkopírovat kliknutím)</span>
                       </td>
                   </tr>-->
          <tr>
            <td class="info-table__title">
              Stav:
            </td>
            <td class="info-table__value">
              <div class="status-wrap">
                <span
                  v-if="data.status === 'paid'"
                  class="status status--table status--success"
                  >Zaplacena</span
                >
                <span
                  v-else-if="data.status === 'created'"
                  class="status status--table"
                  >Vytvořena</span
                >
                <span
                  v-else-if="data.status === 'canceled'"
                  class="status status--table status--error"
                  >Zrušena</span
                >
                <span
                  v-else-if="data.status === 'storned'"
                  class="status status--table status--error"
                  >Stornována</span
                >
                <span
                  v-else-if="data.status === 'timeouted'"
                  class="status status--table status--error"
                  >Vypršela</span
                >
                <span
                  v-else-if="data.status === 'refunded'"
                  class="status status--table status--error"
                  >Platba vrácena</span
                >
                <span
                  v-else-if="data.status === 'to_ship'"
                  class="status status--table"
                  >K odeslání</span
                >
                <span
                  v-else-if="data.status === 'shipped'"
                  class="status status--table status--success"
                  >Odeslána</span
                >
                <span v-else class="status status--table status--normal"
                  >Neznámý<span v-if="data.status">
                    - {{ data.status }}</span
                  ></span
                >
                <v-btn
                  color="secondary"
                  type="button"
                  class="button--text"
                  @click="openDialogStatus"
                  >Změnit</v-btn
                >
              </div>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              ID:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                @input="errors.id = ''"
                v-model="data.id"
                :error-messages="makeError(errors.id)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Číslo objednávky:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                @input="errors.number = ''"
                v-model="data.number"
                :error-messages="makeError(errors.number)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Zákazník:
            </td>
            <td class="info-table__value ">
              <div class="info-table-value-flex">
                <v-text-field
                  disabled
                  class="input--large"
                  outlined
                  @input="errors.user_data = ''"
                  v-model="data.user_data"
                  :error-messages="makeError(errors.user_data)"
                >
                </v-text-field>
                <v-btn
                  color="primary"
                  type="submit"
                  class="button--inputs"
                  @click="customerDetail()"
                >
                  detail
                </v-btn>
              </div>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Vytvořeno:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                @input="errors.created_at = ''"
                v-model="data.created_at"
                :error-messages="makeError(errors.created_at)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Počet produktů:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--smaller"
                outlined
                @input="errors.items_count = ''"
                v-model="data.items_count"
                :error-messages="makeError(errors.items_count)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.currency == 'CZK'">
            <td class="info-table__title">Cena:<br /><span>(Kč)</span></td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--smaller"
                outlined
                @input="errors.price = ''"
                v-model="data.price"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.currency == 'EUR'">
            <td class="info-table__title">Cena:<br /><span>(€)</span></td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--smaller"
                outlined
                @input="errors.price = ''"
                v-model="data.price_eur"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.currency == 'CZK'">
            <td class="info-table__title">
              Cena bez DPH:<br /><span>(Kč)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--smaller"
                outlined
                @input="errors.price_no_dph = ''"
                v-model="data.price_no_dph"
                :error-messages="makeError(errors.price_no_dph)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.currency == 'EUR'">
            <td class="info-table__title">
              Cena bez DPH:<br /><span>(€)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--smaller"
                outlined
                @input="errors.price_no_dph = ''"
                v-model="data.price_eur_no_dph"
                :error-messages="makeError(errors.price_no_dph)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Platba s DPH:<br /><span>(Kliknutím se uloží)</span>
            </td>
            <td class="info-table__value">
              <v-checkbox
                @click="checkDph()"
                class="input--small"
                outlined
                v-model="data.dph"
                @input="errors.dph = ''"
                :error-messages="makeError(errors.dph)"
              >
              </v-checkbox>
            </td>
          </tr>
          <tr v-if="data.delivery_country">
            <td
              class="info-table__title"
            >
              Země:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{data.delivery_country == 'czech' ? 'Česko' : 'Slovensko'}}
            </td>
          </tr>
          <tr v-if="data.delivery_address">
            <td
              class="info-table__title"
              v-if="data.delivery_address.first_name"
            >
              Jméno a příjmení:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.first_name }}
              {{ data.delivery_address.last_name }}
            </td>
          </tr>
          <tr v-if="data.delivery_address">
            <td
              class="info-table__title"
              v-if="data.delivery_address.phone_number"
            >
              Telefon:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.phone_number }}
            </td>
          </tr>
          <tr v-if="data.delivery_address">
            <td class="info-table__title" v-if="data.delivery_address.city">
              Adresa:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.city }},
              {{ data.delivery_address.street }} {{ data.delivery_address.zip }}
            </td>
          </tr>
          <tr v-if="data.delivery_address">
            <td
              class="info-table__title"
              v-if="data.delivery_address.company_name"
            >
              Název firmy:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.company_name }}
            </td>
          </tr>
            <tr v-if="data.delivery_address">
            <td
              class="info-table__title"
              v-if="data.delivery_address.company_phone_number"
            >
              Telefon:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.company_phone_number }}
            </td>
          </tr>
          </tr>
            <tr v-if="data.delivery_address">
            <td
              class="info-table__title"
              v-if="data.delivery_address.company_ic"
            >
              IČ:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.company_ic }}
            </td>
          </tr>
            <tr v-if="data.delivery_address">
            <td
              class="info-table__title"
              v-if="data.delivery_address.company_dic"
            >
              DIČ:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.company_dic }}
            </td>
          </tr>
             <tr v-if="data.delivery_address">
            <td class="info-table__title" v-if="data.delivery_address.company_city">
              Adresa:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              {{ data.delivery_address.company_city }},
              {{ data.delivery_address.company_street }} {{ data.delivery_address.company_zip }}
            </td>
          </tr>
             <tr v-if="data.delivery_point_type">
            <td class="info-table__title">
              Doprava:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              <div v-if="data.delivery_point_type == 'ZASILKOVNA'">
                <span>Zásilkovna</span>
                <v-btn :loading="loadingBalikovnaItems" color="primary" type="submit" class="button--small ml-4" v-if="!data.delivery_ext_id" @click="openDialogZasilkovna">Objednat</v-btn>
                <v-btn :loading="loadingLabel" color="primary" type="submit" class="button--small ml-4" v-if="data.delivery_ext_id" @click="downloadLabel">Štítek</v-btn> 
              </div>
              <div v-if="data.delivery_point_type == 'BALIKOVNA'">
              <span>Balíkovna</span>
              <v-btn :loading="loadingBalikovnaItems" color="primary" type="submit" class="button--small ml-4" v-if="!data.delivery_ext_id" @click="openDialogBalikovnaDP">Objednat</v-btn>
              <v-btn :loading="loadingLabel" color="primary" type="submit" class="button--small ml-4" v-if="data.delivery_ext_id" @click="downloadLabel">Štítek</v-btn> 
              </div>
              <div v-if="data.delivery_point_type == 'ZASILKOVNA_SK'">
              <span>Zásilkovna SK</span>
              <v-btn :loading="loadingBalikovnaItems" color="primary" type="submit" class="button--small ml-4" v-if="!data.delivery_ext_id" @click="openDialogZasilkovna">Objednat</v-btn>
                <v-btn :loading="loadingLabel" color="primary" type="submit" class="button--small ml-4" v-if="data.delivery_ext_id" @click="downloadLabel">Štítek</v-btn> 
              </div>
              <template v-if="data.delivery_point_type == 'BALIKOVNA_HD'">
              <span v-if="data.delivery_point_type == 'BALIKOVNA_HD'">Na adresu</span>
              <v-btn :loading="loadingBalikovnaItems" color="primary" type="submit" class="button--small ml-4" v-if="!data.delivery_ext_id" @click="openDialogBalikovna">Objednat</v-btn>
              <v-btn :loading="loadingLabel" color="primary" type="submit" class="button--small ml-4" v-if="data.delivery_ext_id" @click="downloadLabel">Štítek</v-btn> 
              </template>

            </td>
          </tr>
             <tr v-if="data.delivery_ext_id">
            <td class="info-table__title">
              Kód zásilky:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
                <span>{{data.delivery_ext_id}} </span>
            </td>
          </tr>
          <tr v-if="data.delivery_point_type == 'ZASILKOVNA'">
             <td class="info-table__title">
              Adresa:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              <a v-if="data.delivery_point.name && data.delivery_point.place" :href="data.delivery_point.url" target="_blank">
                {{data.delivery_point.name}} - {{data.delivery_point.place}}
              </a>
            </td>
          </tr>
          <tr v-if="data.delivery_point_type == 'ZASILKOVNA_SK'">
             <td class="info-table__title">
              Adresa:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              <a v-if="data.delivery_point.name && data.delivery_point.place" :href="data.delivery_point.url" target="_blank">
                {{data.delivery_point.name}} - {{data.delivery_point.place}}
              </a>
            </td>
          </tr>
          <tr v-if="data.delivery_point_type == 'BALIKOVNA'">
             <td class="info-table__title">
              Adresa:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              <span v-if="data.delivery_point.address && data.delivery_point.name" :href="data.delivery_point.url" target="_blank">
                {{data.delivery_point.address}} - {{data.delivery_point.name}}
              </span>
            </td>
          </tr>
          <tr>
             <td class="info-table__title">
              Cena:<br /><span></span>
            </td>
            <td class="info-table__value" style="vertical-align:bottom;">
              <span>
                {{ data.delivery_price}} <span v-if="data.currency == 'CZK'"> Kč</span><span v-if="data.currency == 'EUR'"> €</span>
              </span>
            </td>
          </tr>
        </table>
      </v-layout>
      <h2>Seznam položek</h2>
      <div
        class="order-items-tab"
        v-if="
          items.filter(
            (item) =>
              item.type === 'audiobook' ||
              item.type === 'ebook' ||
              item.type === 'book'
          ).length > 0
        "
      >
        <h3>Audioknihy</h3>

        <!-- item.type === 'audiobook' -->
        <v-data-table
          locale="cs"
          :headers="headersAudiobooks"
          :items="
            items.filter((item) =>
              ['audiobook', 'ebook', 'book'].includes(item.type)
            )
          "
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="50"
          hide-default-footer
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{
                    name: 'AudiobooksDetail',
                    params: { id: item.audiobook_id },
                  }"
                >
                  <td class="">{{ item.audiobook_id }}</td>
                  <td class="">{{ item.audiobook_name }}</td>
                  <td class="">{{ item.price }} Kč</td>
                  <td>
                    <span v-if="item.type === 'audiobook'">MP3</span>
                    <span v-if="item.type === 'ebook'">e-kniha</span>
                    <span v-if="item.type === 'book'">kniha</span>
                  </td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
        </v-data-table>
      </div>

      <div
        class="order-items-tab"
        v-if="items.filter((item) => item.type === 'audiobook').length > 0"
      >
        <h3>Seznam podpisů</h3>

        <v-data-table
          locale="cs"
          sort-by="created_at"
          sort-desc="true"
          :headers="headersSignatures"
          :items="itemsSignatures"
          :search="search"
          :loading="false"
          item-key="created_at"
          :items-per-page="30"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr
                v-for="item in props.items"
                :key="item.id"
                @click="
                  openDialogDetail(
                    item.signature,
                    item.directory_hash,
                    item.audiobook_id
                  )
                "
              >
                <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                <td class="bold">
                  <router-link
                    :to="{
                      name: 'AudiobooksDetail',
                      params: { id: item.audiobook_id },
                    }"
                  >
                    {{ item.audiobook_name }}<br />
                    <span class="small normal"
                      >ID: {{ item.audiobook_id }}</span
                    >
                  </router-link>
                </td>
                <td class="bold">
                  <router-link
                    :to="{
                      name: 'CustomersDetail',
                      params: { id: item.user_id },
                    }"
                  >
                    {{ item.user_name }}<br />
                    <span class="small normal">ID: {{ item.user_id }}</span>
                  </router-link>
                </td>
                <td class="small">
                  <span
                    v-if="item.signature"
                    @click="
                      openDialogDetail(
                        item.signature,
                        item.directory_hash,
                        item.audiobook_id
                      )
                    "
                  >
                    {{ item.signature.substring(0, 20) }}...
                  </span>
                </td>
                <td class="bold">{{ item.downloaded }}x</td>
                <td class="small bold">
                  <span v-if="item.status === 'ready'" class="status"
                    >{{ item.download_order }}. {{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'failed'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'deleted'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'done'"
                    class="status status--success"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'missing'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'preparing'"
                    class="status"
                    >{{ item.status_name }}</span
                  >
                  <span v-else class="status status--normal"
                    ><span>{{ item.status_name }}</span></span
                  >
                </td>
                <td class="right small">
                  <v-btn
                    v-if="
                      (item.status === 'deleted' && !item.retried) ||
                        (item.status === 'failed' && !item.retried) ||
                        (item.status === 'missing' && !item.retried)
                    "
                    color="primary"
                    type="submit"
                    class="button--small"
                    @click.stop="openDialogGenerate(item)"
                    >Generovat znovu</v-btn
                  >
                </td>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná generovaná kniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>

          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet generovaných knih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </div>

      <div
        class="order-items-tab"
        v-if="
          items.filter((item) =>
            ['audiobook_voucher', 'book_voucher', 'ebook_voucher'].includes(
              item.type
            )
          ).length > 0
        "
      >
        <h3>Audioknihy jako poukaz</h3>

        <v-data-table
          locale="cs"
          :headers="headersAudiobooksVouchers"
          :items="
            items.filter((item) =>
              ['audiobook_voucher', 'ebook_voucher', 'book_voucher'].includes(
                item.type
              )
            )
          "
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="50"
          hide-default-footer
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{
                    name: 'AudiobooksDetail',
                    params: { id: item.audiobook_id },
                  }"
                >
                  <td class="">{{ item.audiobook_id }}</td>
                  <td class="">{{ item.audiobook_name }}</td>
                  <td class="">{{ item.price }} Kč</td>
                  <td>
                    <span v-if="item.type === 'audiobook_voucher'">MP3</span>
                    <span v-if="item.type === 'ebook_voucher'">e-kniha</span>
                    <span v-if="item.type === 'book_voucher'">kniha</span>
                  </td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <div
        class="order-items-tab"
        v-if="items.filter((item) => item.type === 'gift_voucher').length > 0"
      >
        <h3>Dárkové poukazy</h3>

        <v-data-table
          locale="cs"
          :headers="headersAudiobooksVouchers"
          :items="items.filter((item) => item.type === 'gift_voucher')"
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="50"
          hide-default-footer
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{
                    name: 'VouchersDetail',
                    params: { id: item.voucher_id },
                  }"
                >
                  <td class="">{{ item.voucher_id }}</td>
                  <td class="">Dárkový poukaz</td>
                  <td class="">{{ item.price }} Kč</td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádný poukaz nebyl nalezen</p>
              </div>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <div
        class="order-items-tab"
        v-if="items.filter((item) => item.type === 'voucher').length > 0"
      >
        <h3>Poukazy</h3>

        <v-data-table
          locale="cs"
          :headers="headersVouchers"
          :items="items.filter((item) => item.type === 'voucher')"
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="50"
          hide-default-footer
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{
                    name: 'VouchersDetail',
                    params: { id: item.voucher_id },
                  }"
                >
                  <td class="">{{ item.voucher_id }}</td>
                  <td class="uppercase">{{ item.voucher_code }}</td>
                  <td class="">
                    <span v-if="item.voucher_type === 'percentage'">
                      {{ item.percentage }} % na nákup
                    </span>
                    <span v-if="item.voucher_type === 'crowns'">
                      {{ item.voucher_price }} Kč na nákup
                    </span>
                    <span v-if="item.voucher_type === 'audiobook'">
                      {{ item.audiobook_name }} zdarma
                    </span>
                    <span v-if="item.voucher_type === 'audiobook_percentage'">
                      {{ item.voucher_percentage }} % na audioknihu
                      {{ item.voucher_audiobook_name }}
                    </span>
                    <span v-if="item.voucher_type === 'audiobook_crowns'">
                      {{ item.voucher_price }} Kč na audioknihu
                      {{ item.voucher_audiobook_name }}
                    </span>
                    <span v-if="item.voucher_type === 'category_percentage'">
                      {{ item.voucher_percentage }} % na kategorii
                      {{ item.voucher_category_name }}
                    </span>
                  </td>
                  <td class="">
                    <span> {{ item.price }} Kč </span>
                  </td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <div
        class="order-items-tab"
        v-if="items.filter((item) => item.type === 'discount').length > 0"
      >
        <h3>Sleva</h3>

        <v-data-table
          locale="cs"
          :headers="headersAudiobooksVouchers"
          :items="items.filter((item) => item.type === 'discount')"
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="50"
          hide-default-footer
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <td class=""></td>
                <td class="">
                  Sleva za nákup nad {{ item.discount_data.cart_price }} Kč (-{{
                    item.discount_data.percentage
                  }}%)
                </td>
                <td class="">{{ item.price }} Kč</td>
                <td class=""></td>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná sleva nebyla nalezena</p>
              </div>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog v-model="dialogBalikovna" persistent>
      <v-card>
          <form @submit.prevent="orderBalikovnaHD">
        <v-card-title class="headline">Doprava na adresu</v-card-title>
        <v-card-text v-if="balikovnaData">
          <p class="mb-8"><b>Adresa</b></p>
          <v-text-field placeholder="Jméno" v-model="balikovnaData.first_name" label="Jméno" required hide-details class="mb-6" />
          <v-text-field placeholder="Příjmení" v-model="balikovnaData.last_name" label="Příjmení" required hide-details class="mb-6"/>
          <v-text-field placeholder="Adresa" v-model="balikovnaData.address" label="Adresa" required hide-details class="mb-6"/>
          <v-text-field placeholder="Město" v-model="balikovnaData.city" label="Město" required hide-details class="mb-6"/>
          <v-text-field placeholder="PSČ" v-model="balikovnaData.zip" label="PSČ" required hide-details class="mb-6"/>
          <v-text-field placeholder="Email" v-model="balikovnaData.email" label="Email" required hide-details class="mb-6" />
          <v-text-field placeholder="Telefon" v-model="balikovnaData.phone_number" label="Telefon" required hide-details class="mb-6" />
            <p class="mb-8 mt-8"><b>Položky</b></p>
          <div v-for="(i) in balikovnaItems" :key="i.id">
            <div class="d-flex align-center">
            <span class="mr-4">{{i.name}} (váha)</span>
            </div>
          </div>
          <v-text-field type="number" placeholder="Váha" label="Váha" class="input--smaller mt-9" hide-details v-model="balikovnaData.weight" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogBalikovna"
          >
            zavřít
          </v-btn>
          <v-btn color="primary" class="button--dialog" type="submit" :loading="processingBalikovna">Odeslat</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
          </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogBalikovnaDP" persistent>
      <v-card>
          <form @submit.prevent="orderBalikovnaDP">
        <v-card-title class="headline">Doprava na výdejní místo</v-card-title>
        <v-card-text v-if="balikovnaData">
          <p class="mb-8"><b>Adresa</b></p>
          <v-text-field placeholder="Jméno" v-model="balikovnaData.first_name" label="Jméno" required hide-details class="mb-6" />
          <v-text-field placeholder="Příjmení" v-model="balikovnaData.last_name" label="Příjmení" required hide-details class="mb-6"/>
          <v-text-field placeholder="Adresa" v-model="balikovnaData.address" label="Adresa" required hide-details class="mb-6"/>
          <v-text-field placeholder="Město" v-model="balikovnaData.city" label="Město" required hide-details class="mb-6"/>
          <v-text-field placeholder="PSČ" v-model="balikovnaData.zip" label="PSČ" required hide-details class="mb-6"/>
          <v-text-field placeholder="Email" v-model="balikovnaData.email" label="Email" required hide-details class="mb-6" />
          <v-text-field placeholder="Telefon" v-model="balikovnaData.phone_number" label="Telefon" required hide-details class="mb-6" />
            <p class="mb-8 mt-8"><b>Položky</b></p>
          <div v-for="(i) in balikovnaItems" :key="i.id">
            <div class="d-flex align-center">
            <span class="mr-4">{{i.name}}</span>
            </div>
          </div>
          <v-text-field type="number" placeholder="Váha" label="Váha" class="input--smaller mt-9" hide-details v-model="balikovnaData.weight" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogBalikovnaDP"
          >
            zavřít
          </v-btn>
          <v-btn color="primary" class="button--dialog" type="submit" :loading="processingBalikovna">Odeslat</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
          </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogZasilkovna" persistent>
      <v-card>
          <form @submit.prevent="orderZasilkovna">
        <v-card-title class="headline">Doprava na výdejní místo <br>(Zásilkovna)</v-card-title>
        <v-card-text v-if="zasilkovnaData">
          <p class="mb-8"><b>Adresa</b></p>
          <v-text-field placeholder="Jméno" v-model="zasilkovnaData.first_name" label="Jméno" required hide-details class="mb-6" />
          <v-text-field placeholder="Příjmení" v-model="zasilkovnaData.last_name" label="Příjmení" required hide-details class="mb-6"/>
          <v-text-field placeholder="ID Adresy" disabled v-model="zasilkovnaData.address_id" label="ID" required hide-details class="mb-6"/>
          <v-text-field placeholder="Adresa" disabled v-model="zasilkovnaData.address" label="Adresa" required hide-details class="mb-6"/>
          <v-text-field placeholder="Město" disabled v-model="zasilkovnaData.city" label="Město" required hide-details class="mb-6"/>
          <v-text-field placeholder="PSČ" disabled v-model="zasilkovnaData.zip" label="PSČ" required hide-details class="mb-6"/>
          <v-text-field placeholder="Email" v-model="zasilkovnaData.email" label="Email" required hide-details class="mb-6" />
          <v-text-field placeholder="Telefon" v-model="zasilkovnaData.phone_number" label="Telefon" required hide-details class="mb-6" />
            <p class="mb-8 mt-8"><b>Položky</b></p>
          <div v-for="(i) in balikovnaItems" :key="i.id">
            <div class="d-flex align-center">
            <span class="mr-4">{{i.name}}</span>
            </div>
          </div>
          <v-text-field type="number" placeholder="Váha" label="Váha" class="input--smaller mt-9" hide-details v-model="zasilkovnaData.weight" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogZasilkovna"
          >
            zavřít
          </v-btn>
          <v-btn color="primary" class="button--dialog" type="submit" :loading="processingZasilkovna">Odeslat</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
          </form>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogDetail" persistent>
      <v-card>
        <v-card-title class="headline">Celý podpis</v-card-title>
        <v-card-text>
          <span v-if="currentSignature"> {{ currentSignature }}</span>
          <span v-else>Audiokniha ještě nebyla vygenerovaná!</span>
        </v-card-text>
        <v-card-title class="headline">Složka</v-card-title>
        <v-card-text>
          <span
            v-if="currentDirectory"
            @click="copyFolder()"
            style="cursor:pointer"
            ><b ref="folderPath"
              ><i
                >/opt/app/data/prepared_mp3/{{ currentBookId }}/{{
                  currentDirectory
                }}</i
              ></b
            ><br />(zkopírovat kliknutím a zavřít)</span
          >
          <span v-else>Složka ještě nebylo vytvořena!</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogDetail()"
          >
            zavřít
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGenerate" persistent>
      <v-card>
        <v-card-title class="headline">Generovat znovu</v-card-title>
        <v-card-text>
          Opravdu chcete znovu vygenerovat knihu<br /><strong>{{
            currentBook
          }}</strong>
          uživateli <strong>{{ currentName }}</strong
          >? <br /><br />
          <span class="status status--error" v-if="bookAlreadyRemade"
            >Nová kopie audioknihy je už pro uživatele připravena nebo se právě
            připravuje.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogGenerate()"
          >
            zavřít
          </v-btn>
          <v-btn
            v-if="!bookAlreadyRemade"
            color="primary"
            class="button--dialog"
            @click="generateNew()"
          >
            generovat
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="deliverySnackbar" v-html="snackText">
    </v-snackbar>


     <v-snackbar v-model="deliverySnackbar">
          <div v-html="snackText"></div>

          <template v-slot:action="{ attrs }">
            <v-btn color="error" text v-bind="attrs" @click="deliverySnackbar = false, snackText = ''">
              Zavřít
            </v-btn>
          </template>
        </v-snackbar>

    <v-dialog v-model="dialogStatus" persistent>
      <v-card>
        <v-card-title class="headline">Změna stavu platby</v-card-title>
        <v-card-text>
          Opravdu chcete změnit stav platby? Změna stavu může být následně
          ovlivněna službou GoPay!
          <br /><br />
          <b>Aktuální stav</b>
          <div class="status-wrap">
            <span
              v-if="data.status === 'paid'"
              class="status status--table status--success"
              >Zaplacena</span
            >
            <span
              v-else-if="data.status === 'created'"
              class="status status--table"
              >Vytvořena</span
            >
            <span
              v-else-if="data.status === 'canceled'"
              class="status status--table status--error"
              >Zrušena</span
            >
            <span
              v-else-if="data.status === 'storned'"
              class="status status--table status--error"
              >Stornována</span
            >
            <span
              v-else-if="data.status === 'timeouted'"
              class="status status--table status--error"
              >Vypršela</span
            >
            <span
              v-else-if="data.status === 'to_ship'"
              class="status status--table"
              >K odeslání</span
            >
            <span
              v-else-if="data.status === 'shipped'"
              class="status status--table status--success"
              >Odeslána</span
            >
            <span
              v-else-if="data.status === 'refunded'"
              class="status status--table status--error"
              >Platba vrácena</span
            >
            <span v-else class="status status--table status--normal"
              >Neznámý<span v-if="data.status"> - {{ data.status }}</span></span
            >
          </div>
          <br /><br />
          <b>Nový stav</b>
          <v-select
            v-if="!hasPrintedBook"
            :items="statusList"
            v-model="statusToChange"
            outlined
          ></v-select>
          <v-select
            v-if="hasPrintedBook"
            :items="[
              ...statusList,
              ...[
                { value: 'to_ship', text: 'K ODESLÁNÍ' },
                { value: 'shipped', text: 'ODESLÁNO' },
              ],
            ]"
            v-model="statusToChange"
            outlined
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogStatus()"
          >
            zavřít
          </v-btn>
          <v-btn color="primary" class="button--dialog" @click="changeStatus()">
            změnit
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import crypto from "crypto"
import axios from "axios"
import * as https from "https"

export default {
  name: "OrdersDetail",
  components: {},

  data() {
    return {
      dialogZasilkovna:false,
      dialogBalikovnaDP:false,
      statusToChange: "",
      dialogStatus: false,
      loaded: false,
      loadedDownload: false,
      data: {},
      errors: {},
      items: [],
      bookAlreadyRemade: true,
      dialogDetail: false,
      dialogGenerate: false,
      currentBook: "",
      currentName: "",
      currentId: "",
      currentSignature: "",
      currentBookId: "",
      currentDirectory: "",
      search: "",
      hasPrintedBook: false,
      headersAudiobooks: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "ID", value: "id", align: "left" },
        { text: "Název", value: "name", align: "left" },
        { text: "Cena", value: "price", align: "left" },
        { text: "Typ", value: "type", align: "left" },
        { text: "", value: "controls", align: "right" },
      ],
      headersAudiobooksVouchers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "ID", value: "id", align: "left" },
        { text: "Název", value: "name", align: "left" },
        { text: "Cena", value: "price", align: "left" },
        { text: "Typ", value: "type", align: "left" },
        { text: "", value: "controls", align: "right" },
      ],
      headersVouchers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "ID", value: "id", align: "left" },
        { text: "Kód", value: "code", align: "left" },
        { text: "Sleva", value: "voucher_type", align: "left" },
        { text: "Sleva v Kč", value: "voucher_type", align: "left" },
        { text: "", value: "controls", align: "right" },
      ],
      headersSignatures: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "Zahájení generování", value: "created_at", align: "left" },
        { text: "Kniha", value: "audiobook_name", align: "left" },
        { text: "Uživatel", value: "user_name", align: "left" },
        { text: "Podpis", value: "signature", align: "left" },
        { text: "Staženo", value: "downloaded", align: "left" },
        { text: "Stav", value: "status_name", align: "left" },
        { text: "", value: "", align: "left", sortable: false },
      ],
      loadingBalikovnaItems: false,
      dialogBalikovna: false,
      loadingLabel: false,
      balikovnaItems:[],
      itemsSignatures: [],
      balikovnaData: null,
      zasilkovnaData:null,
      deliverySnackbar: false,
      snackText: "",
      processingBalikovna: false,
      processingZasilkovna:false,
      statusList: [
        {
          value: "paid",
          text: "ZAPLACENA",
        },
        {
          value: "canceled",
          text: "ZRUŠENA",
        },
        {
          value: "storned",
          text: "STORNOVÁNA",
        },
      ],
    };
  },

  created() {
    this.fetchData();
  },
  computed: {},
  mounted() {},
  methods: {
    closeDialogZasilkovna(){
      this.dialogZasilkovna = false;
      this.zasilkovnaData = null
    },
    async openDialogZasilkovna(){
      try{
        let zasilkovnaData = JSON.parse(JSON.stringify({
           order_number: String(this.data.number),
              first_name: this.data.delivery_address.first_name,
              last_name: this.data.delivery_address.last_name,
              phone_number: this.data.delivery_address.phone_number,
              address: this.data.delivery_point.name,
              zip: this.data.delivery_point.zip,
              city: this.data.delivery_point.city,
              email: this.data.user_email,
              weight: "1",
              address_id: this.data.delivery_point.id
        }))
        this.zasilkovnaData = zasilkovnaData
        this.loadingBalikovnaItems = true;
        const balikovnaItems = await this.$axios.get(`/admin/orders/balikovna/${this.data.id}/items`)
        this.loadingBalikovnaItems = false
        this.dialogZasilkovna = true
        this.balikovnaItems = balikovnaItems.data.data
      }catch(e){
        console.log(e)
      }
    },
    async openDialogBalikovnaDP(){
      console.log(this.data)
          try {
            let balikovnaData = JSON.parse(JSON.stringify({
              order_number: String(this.data.number),
              first_name: this.data.delivery_address.first_name,
              last_name: this.data.delivery_address.last_name,
              phone_number: this.data.delivery_address.phone_number,
              address: this.data.delivery_point.name,
              zip: this.data.delivery_point.zip,
              city: this.data.delivery_point.municipality_name,
              email: this.data.user_email,
              weight: "1",
            }));
          this.balikovnaData = balikovnaData
        this.loadingBalikovnaItems = true;
        const balikovnaItems = await this.$axios.get(`/admin/orders/balikovna/${this.data.id}/items`)
        this.loadingBalikovnaItems = false
        this.dialogBalikovnaDP = true
        this.balikovnaItems = balikovnaItems.data.data
      } catch (error) {
          this.loadingBalikovnaItems = false
      }
    },
    async downloadLabel(){
      console.log("Download")
      fetch("data:application/pdf;base64," + this.data.delivery_label_path)
        .then(response => response.blob())
        .then(blob => {
            var link = window.document.createElement("a");
            link.href = window.URL.createObjectURL(blob, { type: "application/pdf" });
            link.download = this.data.delivery_ext_id + ".pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    },
    async openDialogBalikovna(){
          try {
            let balikovnaData = JSON.parse(JSON.stringify({
              order_number: String(this.data.number),
              first_name: this.data.delivery_address.first_name,
              last_name: this.data.delivery_address.last_name,
              phone_number: this.data.delivery_address.phone_number,
              address: this.data.delivery_address.street,
              zip: this.data.delivery_address.zip,
              city: this.data.delivery_address.city,
              email: this.data.user_email,
              weight: "1",
            }));
          this.balikovnaData = balikovnaData
        this.loadingBalikovnaItems = true;
        const balikovnaItems = await this.$axios.get(`/admin/orders/balikovna/${this.data.id}/items`)
        this.loadingBalikovnaItems = false
        this.dialogBalikovna = true
        this.balikovnaItems = balikovnaItems.data.data
      } catch (error) {
          this.loadingBalikovnaItems = false
      }
    },
    closeDialogBalikovna(){
      this.dialogBalikovna = false
      this.balikovnaData = null;
      this.balikovnaItems = []
    },
    closeDialogBalikovnaDP(){
      this.dialogBalikovnaDP = false
      this.balikovnaData = null;
      this.balikovnaItems = []
    },
    async orderZasilkovna(){
      try {
        this.processingZasilkovna = true
        const {data}= await this.$axios.post(`/admin/orders/zasilkovna/${this.data.id}`, {
          weight: this.zasilkovnaData.weight,
          firstname: this.zasilkovnaData.first_name,
          lastname: this.zasilkovnaData.last_name,
          email: this.zasilkovnaData.email,
          phoneNumber: this.zasilkovnaData.phone_number,
          addressId: this.zasilkovnaData.address_id
        })
        console.log(data)
          this.data.delivery_ext_id = data.data
          this.data.delivery_label_path = data.labelData
          this.processingZasilkovna = false;
          this.$forceUpdate()
          this.closeDialogZasilkovna()
      } catch (error) {
        this.processingZasilkovna = false;
        console.log(error)
      }
    },
    async orderBalikovnaDP(){
              const fdate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
          }

        const nonce = '0d8873f8-6cf8-4075-88df-f3518c7df527';
  const secret =
    'lF0Co/pfJ8pNQKGSwdQjkCjzrS6mzoGFhpqq4nD9ePUKI/JLMVDAWFAiVAZ9Usz0QrAiey7kGHaJY+60eb2zLg==';

    const apiToken = 'abd5aafa-2d3c-48d0-9dab-c56e5e485567'

    const ep = 'https://b2b.postaonline.cz:444/restservices/ZSKService/v1/parcelService';


      let pd = {
    parcelServiceHeader: {
      parcelServiceHeaderCom: {
        transmissionDate: fdate(new Date()),
        customerID: 'M18657',
        postCode: '77900',
        locationNumber: 1,
      },
      "printParams": {
			"idForm": 101,
			"shiftHorizontal": 0,
			"shiftVertical": 0
		},
		"position": 1
    },
    parcelServiceData: {
      parcelParams: {
        recordID: this.balikovnaData.order_number,
        prefixParcelCode: 'NB',
        weight: String(this.balikovnaData.weight),
        insuredValue: 1500,
        currency: 'CZK'
      },
      parcelServices: ['7', 'M'],
      parcelAddress: {
        recordID: this.balikovnaData.order_number,
        firstName: this.balikovnaData.first_name,
        surname: this.balikovnaData.last_name,
        address: {
          street: `Balíkovna`, //  ${this.balikovnaData.address}
          zipCode: this.balikovnaData.zip,
          // city: this.balikovnaData.city
        },
        mobilNumber: this.balikovnaData.phone_number,
        emailAddress: this.balikovnaData.email,
      },
    }
  };
  console.log({pd})
    const now = Math.floor(Date.now() / 1000);
    const payloadHash = crypto.createHash("sha256").update(JSON.stringify(pd)).digest("hex");
    const signature = crypto.createHmac("sha256", secret)
      .update(
        `${payloadHash};${now};${nonce}`
      ).digest("base64")

      try {
        this.processingBalikovna = true
       const {data}= await this.$axios.post(`/admin/orders/balikovna/${this.data.id}`, {
          strdata: JSON.stringify(pd),
          payloadHash: payloadHash,
          now: now,
          signature: `CP-HMAC-SHA256 nonce="${nonce}" signature="${signature}"`
        })
        this.processingBalikovna = false

        if(!data.data.success && data.data.messages){
          const messages = data.data.messages.map(m => `${m.responseText} - Kód: ${m.responseCode}`)
          messages.forEach(m => this.snackText += `${m}<br>`)
          this.deliverySnackbar = true
          setTimeout(() => {
            this.snackText = ''
          }, (5000));
        }
        if(data.data.success && data.data.parcelId){
          this.closeDialogBalikovnaDP()
          this.data.delivery_ext_id = data.data.parcelId
          this.data.delivery_label_path = data.data.path
          this.$forceUpdate()
        }
      } catch (error) {
        this.processingBalikovna = false
        console.error(error)
      }
    
    },
    async orderBalikovnaHD(){
        const fdate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
          }

        const nonce = '0d8873f8-6cf8-4075-88df-f3518c7df527';
  const secret =
    'lF0Co/pfJ8pNQKGSwdQjkCjzrS6mzoGFhpqq4nD9ePUKI/JLMVDAWFAiVAZ9Usz0QrAiey7kGHaJY+60eb2zLg==';

    const apiToken = 'abd5aafa-2d3c-48d0-9dab-c56e5e485567'

    const ep = 'https://b2b.postaonline.cz:444/restservices/ZSKService/v1/parcelService';


      let pd = {
    parcelServiceHeader: {
      parcelServiceHeaderCom: {
        transmissionDate: fdate(new Date()),
        customerID: 'M18657',
        postCode: '77900',
        locationNumber: 1,
      },
      "printParams": {
			"idForm": 101,
			"shiftHorizontal": 0,
			"shiftVertical": 0
		},
		"position": 1
    },
    parcelServiceData: {
      parcelParams: {
        recordID: this.balikovnaData.order_number,
        prefixParcelCode: 'DR',
        weight: String(this.balikovnaData.weight),
        insuredValue: 1500,
        currency: 'CZK',
      },
      parcelServices: ['7', 'M'],
      parcelAddress: {
        recordID: this.balikovnaData.order_number,
        firstName: this.balikovnaData.first_name,
        surname: this.balikovnaData.last_name,
        address: {
          street: this.balikovnaData.address,
          sequenceNumber: '',
          houseNumber: '',
          city: this.balikovnaData.city,
          cityPart: '',
          zipCode: this.balikovnaData.zipCode,
          isoCountry: 'CZ',
        },
        mobilNumber: this.balikovnaData.phone_number,
        emailAddress: this.balikovnaData.email,
      },
    }
  };

    const now = Math.floor(Date.now() / 1000);
    const payloadHash = crypto.createHash("sha256").update(JSON.stringify(pd)).digest("hex");
    const signature = crypto.createHmac("sha256", secret)
      .update(
        `${payloadHash};${now};${nonce}`
      ).digest("base64")

      try {
        this.processingBalikovna = true
       const {data}= await this.$axios.post(`/admin/orders/balikovna/${this.data.id}`, {
          strdata: JSON.stringify(pd),
          payloadHash: payloadHash,
          now: now,
          signature: `CP-HMAC-SHA256 nonce="${nonce}" signature="${signature}"`
        })
        this.processingBalikovna = false

        if(!data.data.success && data.data.messages){
          const messages = data.data.messages.map(m => `${m.responseText} - Kód: ${m.responseCode}`)
          messages.forEach(m => this.snackText += `${m}<br>`)
          this.deliverySnackbar = true
          setTimeout(() => {
            this.snackText = ''
          }, (5000));
        }
        if(data.data.success && data.data.parcelId){
          this.closeDialogBalikovna()
          this.data.delivery_ext_id = data.data.parcelId
          this.data.delivery_label_path = data.data.path
          this.$forceUpdate()
        }
      } catch (error) {
        this.processingBalikovna = false
        console.error(error)
      }
    
    },
    changeStatus() {
      const request = {
        status: this.statusToChange,
      };
      this.$axios
        .put("/admin/orders/" + this.data.id + "/status", request)
        .then((response) => {
          this.closeDialogStatus();
          this.fetchData();
        })
        .catch((e) => {
          this.closeDialogStatus();
          this.fetchData();
        });
    },
    checkDph() {
      const request = this.data;
      this.$axios
        .post("/admin/audiobooks/dph/" + this.data.id, request)
        .then((response) => {
          this.fetchData();
        })
        .catch((e) => {
          this.fetchData();
        });
    },
    closeDialogDetail() {
      this.dialogDetail = false;
    },
    openDialogDetail(signature, directory, audiobook_id) {
      this.currentSignature = signature;
      this.currentDirectory = directory;
      this.currentBookId = audiobook_id;
      this.dialogDetail = true;
    },

    closeDialogStatus() {
      this.dialogStatus = false;
    },
    openDialogStatus() {
      this.statusToChange = this.data.status;
      this.dialogStatus = true;
    },
    closeDialogGenerate() {
      this.dialogGenerate = false;
    },
    openDialogGenerate(item) {
      this.$axios
        .get("/admin/audiobooks/downloads/check/" + item.id)
        .then((response) => {
          this.currentBook = item.audiobook_name;
          this.currentName = item.user_name;
          this.currentId = item.id;
          this.dialogGenerate = true;
          this.bookAlreadyRemade = response.data.retried;

          if (response.data.retried) {
            this.fetchData();
          }
        })
        .catch((e) => {
          this.currentBook = item.audiobook_name;
          this.currentName = item.user_name;
          this.currentId = item.id;
          this.bookAlreadyRemade = true;
          this.dialogGenerate = true;
        });
    },
    generateNew() {
      this.$axios
        .post("/admin/audiobooks/downloads/new/" + this.currentId)
        .then((response) => {
          this.fetchData();
          this.dialogGenerate = false;
        })
        .catch((e) => {
          this.dialogGenerate = false;
        });
    },

    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    copyBilling() {
      this.selectText(this.$refs.billingId);
      document.execCommand("copy");
    },
    copyNumber() {
      this.selectText(this.$refs.numberId);
      document.execCommand("copy");
    },
    copyGopay() {
      this.selectText(this.$refs.gopayId);
      document.execCommand("copy");
    },
    copyFolder() {
      this.selectText(this.$refs.folderPath);
      document.execCommand("copy");
      this.$nextTick(() => {
        this.closeDialogDetail();
      });
    },

    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format("D.M.YYYY - HH:mm");
      } else {
        return null;
      }
    },

    makeError(item) {
      if (item === "required") {
        return "Toto pole je povinné";
      } else if (item === "already_used") {
        return "Je již používaný";
      } else if (item === "not_valid") {
        return "Neplatný formát";
      } else if (item === "max_price") {
        return "Překročena cena knihy";
      } else if (item === "not_in_range") {
        return "Není v rozmezí 1 - 100";
      } else if (item) {
        return "Neznámá chyba";
      } else {
        return "";
      }
    },

    customerDetail() {
      this.$router.push({
        name: "CustomersDetail",
        params: { id: this.data.user_id },
      });
    },

    downloadBilling() {
      this.loaded = false;
      this.$axios
        .get(
          "/admin/orders/vyfakturuj/" + this.data.vyfakturuj_id + "/download"
        )
        .then((response) => {
          if (response.data.url) {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.target = "_blank";
            link.setAttribute("download", this.data.number.toString() + ".pdf"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    fetchData() {
      this.$axios
        .get("/admin/orders/" + this.$route.params.id)
        .then((response) => {
          this.data = response.data.order;
          this.data.created_at = this.formatCreatedAt(this.data.created_at);
          this.items = response.data.order_items;

          this.items.map((i) => {
            if (i.type == "book") this.hasPrintedBook = true;
          });

          response.data.signatures.forEach((item) => {
            if (item.status === "missing") {
              item.status_name = "Neexistuje";
            } else if (item.status === "deleted") {
              item.status_name = "Smazáno";
            } else if (item.status === "failed") {
              item.status_name = "Chybně vygenerováno";
            } else if (item.status === "ready") {
              item.status_name = "V pořadí";
            } else if (item.status === "preparing") {
              item.status_name = "Připravuje se";
            } else if (item.status === "done") {
              item.status_name = "Připraveno";
            } else {
              if (item.status) {
                item.status_name = "Neznámý - " + item.status;
              } else {
                item.status_name = "Neznámý";
              }
            }
          });
          this.itemsSignatures = response.data.signatures;
          this.loaded = true;
        })
        .catch((e) => {
          this.$router.push({ name: "Orders" });
          this.loaded = true;
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
